import React from 'react'
import styles from './styles.css'
import stylesSign from './Sign/styles.css'
import stylesText from './Text/styles.css'
import stylesUpload from './Upload/styles.css'
import CloseIcon from 'react-icons/lib/md/close'
import MySignaturesMini from './MySignaturesMini'
import Button from 'orionsoft-parts/lib/components/Button'
import withKeyboardEvent from 'orionsoft-parts/lib/decorators/withKeyboardEvent'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import BrowseVersion from './BrowseVersion'
import {Form, Field} from 'simple-react-form'
import upload from 'App/helpers/fields/upload'
import SignaturePad from 'react-signature-pad'
import signatureDataFragment from './signatureDataFragment'
import imageUpload from '../../../helpers/fields/imageUpload'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'

const dataURLtoFile = function(dataurl, filename) {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = window.atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  // console.log("Filename de dataURLtoFile es " + filename) 
  return new window.File([u8arr], filename, {type: mime})
}
@withMessage
@withMutation(gql`
  mutation addSignature($image: FileInput) {
    addSignature(image: $image) {
      ...signatureData
    }
  }
  ${signatureDataFragment}
`)
@withMutation(gql`
  mutation setDefaultSignature($signatureId: ID!) {
    setDefaultSignature(signatureId: $signatureId) {
      ...signatureData
    }
  }
  ${signatureDataFragment}
`)

@withKeyboardEvent('escape', 'close')
export default class Signatures extends React.Component {
  static propTypes = {
    isReady: PropTypes.func,
    isDefault: PropTypes.bool,
    setDefaultSignature: PropTypes.func
  }

  state = {
    padIsEmpty: true,
    active: 'current',
    signatureText: '',
    fontName: 'Caveat',
    loadingCanvas: false,
    settingDefaultSignature: false
  }

  theCanvas
  theContext

  close() {
    global.closeSignature()
  }

  async chooseSignature() {
    switch (this.state.active) {
      case 'current':
        break
      case 'upload':
        await this.saveUpload()
        break
      case 'text':
        await this.saveText()
        break
      case 'draw':
        await this.saveSign()
        break
      default:
        break
    }
    this.close()
  }

  renderActive() {
    switch (this.state.active) {
      case 'current':
        return <MySignaturesMini ifEmpty={this.secondDefault} isReady={this.isReady} isDefault={this.props.isDefault} />
      case 'upload':
        return this.renderUpload()
      case 'text':
        return this.renderText()
      case 'draw':
        return this.renderSign()
      default:
        break
    }
  }

  @autobind
  secondDefault() {
    this.setState({active: 'draw'})
  }

  @autobind
  isReady(signatureId) {
    console.log('This isReady')
    this.props.isReady(signatureId)
    this.close()
  }

  renderClose() {
    return (
      <div onClick={this.close} className={styles.closeIcon}>
        <CloseIcon size={20} />
      </div>
    )
  }

  @autobind
  async setDefault(signatureId) {
    await this.setState({settingDefaultSignature: true})
    try {
      await this.props.setDefaultSignature({signatureId})
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    await this.setState({settingDefaultSignature: false})
    this.close()
  }

  // RenderUpload - start
  @autobind
  async saveUpload() {
    await this.setState({loadingCanvas: true})
    try {
      let addedSignature = await this.props.addSignature({image: this.state.image})
      let signatureId = addedSignature.addSignature.signatures.slice(-1)[0]._id
      global.selSignatureId = signatureId
      this.setDefault(signatureId)
      this.props.showMessage('Firma lista')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    await this.setState({loadingCanvas: false})
  }
  renderUpload() {
    return (
      <div className={stylesUpload.container}>
        <Form state={this.state} onChange={changes => {this.setState(changes)}}>
          <Field fieldName="image" label="File" {...imageUpload} placeholder="Subir archivo"/>
        </Form>
        <div className={stylesUpload.pickBtn}>
          {this.state.image || (
            <Button primary onClick={() => this.chooseSignature()}>Elegir</Button>
          )}
        </div>
        <BrowseVersion />
      </div>
    )
  }
  // RenderUpload - end

  // RenderText - start
  @autobind
  async saveText() {
    await this.setState({loadingCanvas: true})
    const base64 = this.theCanvas.toDataURL()
    await this.setState({base64})
    const file = dataURLtoFile(base64)
    // console.log("File es " + JSON.stringify(file))
    const {url} = await upload(file)
    try {
      let addedSignature = await this.props.addSignature({image: {url}})
      let signatureId = addedSignature.addSignature.signatures.slice(-1)[0]._id
      global.selSignatureId = signatureId
      this.setDefault(signatureId)
      this.props.showMessage('Firma lista')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    await this.setState({loadingCanvas: false})
  }
  @autobind
  async onInputChange () {
    const theText = await document.getElementById('textCanvasValue').value
    await this.setState({signatureText: theText})
    this.onTextUpdate()
  }
  async changeFont (fontName) {
    await this.setState({fontName: fontName})
    this.onTextUpdate()
  }
  onTextUpdate = () => {
    if (this.theContext) {
      console.log('hay Context fuera', this.theContext)
      this.theContext.clearRect(0, 0, 830, 360)
      this.theContext.font = `100px "${this.state.fontName}"`
      this.theContext.fillStyle = '#111111'
      this.theContext.fillText(this.state.signatureText, 15, 195)
      console.log('canvasDataURL', this.theCanvas.toDataURL())
    }
    this.setState({signatureText: document.getElementById('textCanvasValue').value})
  }
  refHandler = (canvas) => {
    if (!canvas) return
    this.theCanvas = canvas
    this.theContext = canvas.getContext('2d')
  }
  renderText() {
    return (
      <div className={stylesText.container}>
        <div className="hiddenFontLoader">
          <span className="font-caveat">Caveat</span>
          <span className="font-dancingScript">Dancing Script</span>
        </div>
        <div className="top">
          <input className="os-input-text" id="textCanvasValue" type="text" value={this.state.signatureText} onChange={this.onInputChange} placeholder="Escribe hasta 20 caracteres" maxLength={20}/>
        </div>
        <canvas ref={this.refHandler} id="textCanvas" width={830} height={360} />
        {this.state.signatureText && this.state.signatureText.length > 0 && (
          <div>
            <div className={stylesText.title}>Elige un tipo de letra</div>
            <div className="fontSelectorWrapper">
              <div className="fontSelector font-caveat" onClick={() => this.changeFont('Caveat')}>{this.state.signatureText}</div>
              <div className="fontSelector font-euphoriaScript" onClick={() => this.changeFont('Euphoria Script')}>{this.state.signatureText}</div>
            </div>
            <div className={stylesText.pickBtn}>
              <Button primary onClick={() => this.chooseSignature()}>Elegir</Button>
            </div>
          </div>
        )}
        <BrowseVersion />
      </div>
    )
  }
  // RenderText - end

  // RenderSign - start
  @autobind
  clearSign() {
    this.pad.clear()
  }

  @autobind
  async saveSign() {
    this.setState({loadingCanvas: true})
    const base64 = this.pad.toDataURL()
    this.setState({base64})
    const file = dataURLtoFile(base64)
    // console.log("File es " + JSON.stringify(file))
    const {url} = await upload(file)
    try {
      let addedSignature = await this.props.addSignature({image: {url}})
      let signatureId = addedSignature.addSignature.signatures.slice(-1)[0]._id
      global.selSignatureId = signatureId
      this.setDefault(signatureId)
      console.log('saveSign signatureId:', signatureId)
      this.props.showMessage('Firma lista')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loadingCanvas: false})
  }

  setNewSignature(type) {
    if (type !== 'none') {
      this.setState({active: type})
    }
    this.setState({showButtons: false})
  }

  renderSign() {
    return (
      <div className={stylesSign.container}>
        <div className="padContainer">
          <SignaturePad
            onEnd={() => { this.setState({padIsEmpty: false}) }}
            ref={pad => {
              this.pad = pad
            }}
          />
          {this.state.padIsEmpty && (
            <div className="legend">Dibuja aquí tu firma</div>
          )}
        </div>
        <div className="actions">
          <Button onClick={this.clearSign}>Volver a empezar</Button>
          <Button primary onClick={() => this.chooseSignature()} disabled={this.state.padIsEmpty}>Elegir</Button>
        </div>
        <BrowseVersion />
      </div>
    )
  }
  // RenderSign - end

  // Main render
  render() {
    return (
      <div className={styles.shadow} onClick={this.close}>
        <div className={styles.container} onClick={e => e.stopPropagation()}>
          <div className={'signboxContent ' + this.state.active}>
            <div className='loader'/>
            {this.renderActive()}
          </div>
          <div className="footer">
            <div>
              <Button primary onClick={() => this.setState({active: 'current'})}>Mis firmas</Button>
            </div>
            <div className="newSignature">
              <Button primary onClick={() => this.setState({showButtons: !this.state.showButtons})}>Crear Firma</Button>
              {this.state.showButtons && (
                <div className="wrapper">
                  <div className="btn right" onClick={() => this.setNewSignature('none')}>×</div>
                  <div className="btn submenu" onClick={() => this.setNewSignature('draw')}>Dibujar firma</div>
                  <div className="btn submenu" onClick={() => this.setNewSignature('text')}>Firmar con texto</div>
                  <div className="btn submenu" onClick={() => this.setNewSignature('upload')}>Cargar firma</div>
                </div>
              )}
            </div>
            <div></div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Signature/index.js